/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';
          
    export interface IMapElement {
         x: number;
         y: number;
         href: string;
         name: string;
         status?: string;
    }
    
    export interface ILink extends ITopologyElement {
         from: IRef;
         to: IRef;
         networkInterface: Models.INetworkInterface;
         href: string;
         fromName?: string;
         toName?: string;
         fromTo?: string;
    }
    
    export interface IRef {
        href: string;
    }
    
    export class Link implements ILink {
        public href: string;
        public fromName: string;
        public toName: string;

        public static Empty(): Link {
            return new Link(undefined, undefined, undefined);
        }

        constructor(public from: IRef,
                    public to: IRef,
                    public networkInterface: Models.INetworkInterface) {
            this.href = '';
            this.fromName = '';
            this.toName = '';
        }

        public class(): TopologyElementType {
            return TopologyElementType.Link;
        }
        
        public getDisplayImage(): string {
            return 'images/iconmonstr-link-6-240.png';
        }
    }
    
    export class Ref implements IRef {
        public href: string;

        public static New(href: string): Ref {
            return new Ref(href);
        }

        constructor(href: string) {
            this.href = href;
        }
    }
    
    // export interface ILinkForm {
    //     from?: Models.INetworkNode | Models.INetwork | Models.IGateway | Models.IProbe | Models.IHotspot;
        
    //     to?: Models.INetworkNode | Models.INetwork | Models.IGateway | Models.IProbe | Models.IHotspot;
        
    //     data?: {
    //         id?: string;
    //     };
        
    //     /* tslint:disable */callback?: any;/* tslint:enable */
    // }
}